export function ModelsFactory<T>(rawData: any[], modelFactory: (data: any) => T): T[] {
  if (!rawData || !rawData.length) {
    return [];
  }

  return rawData.map((item) => {
    return modelFactory(item);
  });
}
